import clientLogo from "../../images/clients/Colored/Net_Atlantic.png"

const netAtlantic = {
  pageTitle: "Visiomate - Net Atlantic Case Study",
  metaDescription:
    "Visiomate rebuilt Net Atlantic's email marketing platform, NextMail, with a modern stack, visual editor, automation and analytics — 35% faster campaign deployment.",
  clientName: "Net Atlantic",
  bannerSummary: "A rebuilt email marketing platform for an email service provider running since 1995",
  introHeading: "Email Marketing Platform Modernization for Net Atlantic",
  heroImageAlt: "Working on a laptop",
  clientLogoSrc: clientLogo,
  about:
    "Net Atlantic is a pioneering email service provider that has helped organisations deliver billions of messages since 1995. Focused on high-volume deliverability, it set out to modernise email marketing with NextMail, a user-centric, high-performance platform.",

  challengesIntro: "The old platform was holding back both the product and the marketers using it.",
  challenges: [
    {
      title: "Legacy Infrastructure Constraints",
      desc: "Existing systems were becoming hard to scale and maintain, slowing the release of new features.",
    },
    {
      title: "Complex User Experience",
      desc: "Older tools needed technical knowledge, creating friction for marketers who want speed and simplicity.",
    },
    {
      title: "Scalability Bottlenecks",
      desc: "Handling huge concurrent email broadcasts needed a more resilient, modern architecture.",
    },
    {
      title: "Limited Real-Time Insights",
      desc: "Marketers lacked instant visibility into campaign performance and subscriber behaviour.",
    },
  ],

  solutionsIntro: "We rebuilt the platform on a modern stack, from the editor to the analytics.",
  solutions: [
    {
      num: "01",
      text: "Modern Tech Stack Migration",
      desc: "A move to a scalable, cloud-native architecture that improves performance and cuts maintenance.",
    },
    {
      num: "02",
      text: "Drag-and-Drop Editor",
      desc: "A visual builder for professional, responsive emails in minutes.",
    },
    {
      num: "03",
      text: "Behavioural Automation Engine",
      desc: "Workflows that trigger emails from specific user actions and engagement patterns.",
    },
    {
      num: "04",
      text: "Deliverability Suite",
      desc: "Monitoring tools for strong inbox placement and sender reputation.",
    },
    {
      num: "05",
      text: "High-Speed API Integration",
      desc: "Data syncs with external CRM and e-commerce platforms.",
    },
    {
      num: "06",
      text: "Analytics Dashboard",
      desc: "Real-time reporting on opens, clicks and conversions.",
    },
  ],

  resultsIntro: "Marketers now build, send and measure campaigns faster.",
  metrics: [
    { metric: "35%", label: "Faster campaign deployment, from first draft to final send" },
    { metric: "6", label: "Core capabilities built into NextMail, from the editor to analytics" },
    { metric: "Real time", label: "Engagement tracking for every campaign" },
  ],
  outcomes: [
    "A simpler interface that has driven a significant increase in platform adoption",
    "A scalable platform that stays reliable through massive spikes in volume",
    "Lower running costs through automated maintenance and optimised cloud use",
  ],

  relatedLinks: [
    {
      to: "/caseStudies/projects/ttiTestingLaboratories",
      label: "Read the TTI Testing Laboratories story",
      note: "A lab system connected to Odoo, with automated HR, loan and leave workflows.",
    },
    {
      to: "/caseStudies/projects/centricEvents",
      label: "See the Centric Events story",
      note: "One connected system from first enquiry to final invoice.",
    },
  ],
}

export default netAtlantic
